<template>
    <figure class="general-gold" v-bind:class="sponsor.sponsorCategory === 'General' ? 'general' : 'gold'" v-if="sponsor.sponsorCategory === 'General' || sponsor.sponsorCategory === 'Gold'">
        <a v-if="sponsor.websiteUrl" class="general-gold-main-link" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
          <div class="general-slider-container" v-if="sponsor.sponsorCategory === 'General'">
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(1)" v-bind:alt="`${sponsor.name} pozadina`" />
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(2)" v-bind:alt="`${sponsor.name} pozadina`" />
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(3)" v-bind:alt="`${sponsor.name} pozadina`" />
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(4)" v-bind:alt="`${sponsor.name} pozadina`" />
            <div class="sponsor-dots">
              <div class="sponsor-dot"></div>
              <div class="sponsor-dot"></div>
              <div class="sponsor-dot"></div>
              <div class="sponsor-dot"></div>
            </div>
          </div>
          <template v-else>
            <img v-bind:src="backgroundImageUrl" v-bind:alt="`${sponsor.name} pozadina`">
          </template>
          <ul>
            <li>{{sponsor.sponsorCategory === 'General' ? 'Generalni' : 'Zlatni'}} sponzor</li>
            <li>{{sponsor.name}}</li>
          </ul>
        </a>
        <a v-else>
          <div class="general-slider-container" v-if="sponsor.sponsorCategory === 'General'">
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(1)" v-bind:alt="`${sponsor.name} pozadina`" />
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(2)" v-bind:alt="`${sponsor.name} pozadina`" />
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(3)" v-bind:alt="`${sponsor.name} pozadina`" />
            <img class="general-slider" v-bind:src="getGeneralBackgroundImageUrl(4)" v-bind:alt="`${sponsor.name} pozadina`" />
            <div class="sponsor-dots">
              <div class="sponsor-dot"></div>
              <div class="sponsor-dot"></div>
              <div class="sponsor-dot"></div>
              <div class="sponsor-dot"></div>
            </div>
          </div>
          <template v-else>
            <img v-bind:src="backgroundImageUrl" v-bind:alt="`${sponsor.name} pozadina`">
          </template>
          <ul>
            <li>{{sponsor.sponsorCategory === 'General' ? 'Generalni' : 'Zlatni'}} sponzor</li>
            <li>{{sponsor.name}}</li>
          </ul>
        </a>
      <figcaption>
        <div>
          <a v-if="sponsor.websiteUrl" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
            <img v-bind:src="logoUrl" v-bind:alt="`${sponsor.name} logo`" />
          </a>
          <a v-else>
            <img v-bind:src="logoUrl" v-bind:alt="`${sponsor.name} logo`" />
          </a>
        </div>
        <p>
            {{sponsor.description}}
        </p>
      </figcaption>
    </figure>
    <figure class="other" v-bind:class="sponsorNameNormalized" v-else-if="sponsor">
        <a v-if="sponsor.websiteUrl" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
          <img v-bind:src="logoUrl" v-bind:alt="`${sponsor.name} logo`" />
        </a>
        <a v-else>
          <img v-bind:src="logoUrl" v-bind:alt="`${sponsor.name} logo`" />
        </a>
    </figure>
</template>

<script>
    export default {
      name: 'Sponsor',
      data() {
        return {
          slideIndex: 1,
          generalImages: []
        }
      },
      props: {
          sponsor: {}
      },
      computed: {
          sponsorNameNormalized: function () {
              return this.sponsor.name.replace(/\s/g, '').toLowerCase();
          },
          backgroundImageUrl: function () {
              return require(`../../assets/companies/backgrounds/${this.sponsorNameNormalized}.jpg`);
          },
          logoUrl: function () {
              return require(`../../assets/companies/logos/${this.sponsorNameNormalized}.png`);
          }
      },
      methods: {
        getGeneralBackgroundImageUrl: function(index) {
          return require(`../../assets/companies/backgrounds/${this.sponsorNameNormalized}-${index}.jpg`);
        },
        carousel: function() {
          this.generalImages.forEach(generalImage => generalImage.style.opacity = 0);
          this.dots.forEach(dot => dot.classList.remove("active"));

          this.generalImages[this.slideIndex-1].style.opacity = 1;
          this.dots[this.slideIndex-1].classList.add("active");

          this.slideIndex++;

          if(this.slideIndex > this.generalImages.length)
            this.slideIndex = 1;
        }
      },
      mounted() {
        if(this.sponsor.sponsorCategory === 'General')
        {
          this.generalImages = [...document.getElementsByClassName('general-slider')];
          this.dots = [...document.getElementsByClassName('sponsor-dot')];
          this.carousel();
          this.refreshIntervalId = setInterval(this.carousel, 5000);
        }
      },
      beforeDestroy() {
        if(this.sponsor.sponsorCategory === 'General')
          clearInterval(this.refreshIntervalId);
      }
    }
</script>

<style scoped>
figure {
  margin-bottom: 65px;
}

figure.other {
  flex-basis: 50%;
  height: 100px;
  margin-top: 20px;
  margin-right: 8%;
  margin-bottom: 0;
}

figure.other a {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

figure.other img {
  max-height: 100%;
  max-width: 100%;
}

figure.other.atos img,
figure.other.bundesdruckerei img,
figure.other.fesb img {
  transform: scale(0.7);
}

figure.other.gradsplit img,
figure.other.sveučilišteusplitu img,
figure.other.županija img {
  transform: scale(0.8);
}

figure.other.shift img {
  transform: scale(0.9);
}

figure.other.hiperprodukcija img,
figure.other.hrprodigy img  {
  transform: scale(1.1);
}

figure.other.hrcloud img,
figure.other.infobip img,
figure.other.netmedia img {
  transform: scale(1.2);
}

figure.other.dobartek\.hr img {
  transform: scale(1.3);
}

figcaption {
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.04);
  background-color: #ffffff;
  padding: 0 15px;
  color: rgba(0, 0, 0, 0.65);
  font-family: "Fuse V.2 Display";
  font-size: 14px;
  line-height: 24px;
}

figure.general-gold > a > img {
  width: 100%;
  box-shadow: 0 11px 44px 0 rgba(0, 0, 0, 0.19);
}

figcaption p {
  color: rgb(0, 0, 0, 0.65);
  font-family: "Fuse V.2 Display";
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 30px;
}

figcaption div {
  margin-bottom: -40px;
}

figcaption div::after {
  content: "";
  display: table;
  clear: both;
}

figure.general-gold.general figcaption img {
  width: 160px;
  float: left;
  margin-left: -45px;
  margin-top: -50px;
}

ul {
  box-shadow: 0 11px 44px 0 rgba(0, 0, 0, 0.19);
  padding: 18px;
  background-color: #2c373f;
  transform: translateY(-25%);
  margin-right: -20px;
  max-width: 200px;
  list-style-type: none;
  margin-left: auto;
  float: right;
  width: 100%;
}

li:first-of-type {
  color: #ffffff;
  font-family: "Fuse V.2 Display";
  font-weight: 800;
  font-size: 14px;
  line-height: 16px;
}

li:last-of-type {
  margin-top: 5px;
  color: #30cec1;
  font-family: "Fuse V.2 Display";
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
}

figure.general-gold.general figcaption {
  min-height: 200px;
}

figure.general-gold.general:first-of-type ul {
  padding: 30px;
  padding-bottom: 15px;
  background-color: #30cec1;
  transform: translateY(-100%);
}

figure.general-gold.gold:nth-of-type(2) a.general-gold-main-link {
  margin-right: 30px;
}

figure.general p {
  padding-bottom: 20px;
}

figure.general-gold.gold p {
  margin-top: 100px;
}

figure.general-gold.gold:first-of-type p {
  margin-top: 150px;
}

figure:first-of-type li:first-of-type {
  font-size: 14px;
  line-height: 16px;
}

figure.general li:last-of-type {
  font-size: 26px;
  line-height: 31px;
  color: #001618;
}

figure:nth-child(2n + 4) ul {
  float: left;
  margin-left: -15px;
}

figure:nth-child(2n + 4) figcaption img {
  float: right;
}

figure.gold ul {
  background-color: #2C373F;
}

figure.gold ul li:last-of-type {
  color: #30cec1;
}

figure.general-gold.gold figcaption img {
  height: 100%;
  width: auto;
}

figure.general-gold.gold figcaption {
  margin-top: -5px;
}

figure.general-gold.general-gold:nth-of-type(2) figcaption img {
  transform: scale(0.4);
  margin-right: -105px;
}


figure.general-gold.gold:last-of-type figcaption img {
  transform: scale(0.3);
  margin-left: -130px;
}

figure.general-gold.gold figcaption a {
  display: inline-block;
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
  margin-top: 0;
}

figure.general-gold.gold ul {
  position: absolute;
  right: 50px;
}

figure.general-gold.gold:nth-of-type(2) ul {
  right: auto;
  left: 35px;
}

figure.general-gold.gold:nth-of-type(2) figcaption img {
  float: right;
}

.general-slider-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.general-slider {
  transition: 2s;
  position: absolute;
  width: 100%;
  height: 50%;
}

.sponsor-dots {
  position: absolute;
  top: 55%;
  left: 0;
  display: none;
}

.sponsor-dot {
  margin: 0 10px;
  height: 5px;
  width: 30px;
  background-color: rgb(0, 0, 0, 0.6);
  background-color: #30cec1;
  opacity: 0.4;
}

.sponsor-dot.active {
  opacity: 1;
}

figure.general-gold.general a {
  display: inline-block;
  position: relative;
  width: 100%;
}

figure.general-gold.general a.general-gold-main-link {
  height: 250px;
}

figure.general-gold.general figcaption a {
  margin-top: 0;
}

figure.general-gold.general figcaption {
  padding-top: 6%;
}

figure.gold > a > img {
  height: 250px;
  width: 100%;
}

@media screen and (min-width: 450px) {
  figure.general-gold.general:first-of-type ul {
    padding: 20px;
    transform: translateY(-55%);
    max-width: 200px;
  }
}

@media screen and (max-width: 450px) {
  figure.general-gold.general figcaption img {
    margin-top: -40px;
  }

  figure.gold ul {
    max-width: 170px;
  }

  figure.gold > a > img {
    height: 200px;
  }
}

@media screen and (min-width: 550px) {
  figure.general-gold.general:first-of-type ul li:last-of-type {
    font-size: 26px;
  }
}

@media screen and (min-width: 480px) {
  figure.other {
    flex-basis: 40%;
  }
} 

@media screen and (min-width: 768px) {
  figure.general-gold {
    width: 50%;
  }

  figure {
    margin-bottom: 0;
  }

  figure.general-gold.gold figcaption a {
    margin-bottom: 0;
  }

  ul {
    max-width: 290px;
  }

  figure:first-of-type ul {
    max-width: 260px;
    transform: none;
  }

  figure.general-gold.general a.general-gold-main-link {
    width: 150%;
    height: auto;
  }

  figure.general-gold.general figcaption {
    margin-top: auto;
    min-height: 500px;
  }

  figure.gold {
    display: flex;
    flex-direction: column;
  }

  figure.gold figcaption {
    padding-top: 0;
    margin-left: 10%;
  }

  figure.gold a {
    position: relative;
  }

  figure.general ul {
    right: 20px;
  }

  figure.general-gold.gold ul {
     right: -50px;
     bottom: -100px;
  }

  .general-gold:nth-of-type(2) {
      margin: -10% 0 -10% auto;
  }

  figure.general-gold.gold:nth-of-type(2) ul {
    left: -50px;
    right: auto;
  }

  li:first-of-type {
    font-size: 18px;
    line-height: 19px;
  }

  figure:first-of-type li:first-of-type {
    line-height: 21px;
    font-size: 18px;
  }

  li:last-of-type {
    font-size: 26px;
    line-height: 31px;
  }

  figure:first-of-type li:last-of-type {
    font-size: 26px;
    line-height: 44px;
  }

  figure.general-gold {
    display: flex;
    position: relative;
  }

  figure.general-gold.general {
    width: 100%;
  }

  figure.general-gold.gold {
    width: 45%;
  }

  figure ul {
    position: absolute;
    right: 260px;
    bottom: 0;
    padding-bottom: 25px;
    padding-top: 30px;
  }

  figure.general-gold:first-of-type > img {
    width: 40%;
    object-fit: contain;
    margin-left: 0;
    height: auto;
    object-fit: contain;
    align-self: flex-start;
    flex: 0 0 auto;
  }

  figure.general:first-of-type figcaption {
    padding: 30px;
    padding-top: 10px;
    margin-top: 60px;
    width: 60%;
  }

  figure.general:first-of-type figcaption img {
    float: none;
    display: inline-block;
    transform: none;
    width: 50%;
    margin-left: -50px;
    margin-top: 0;
  }

  figure.gold figcaption img {
    margin-top: 10px;
    margin-left: 10px;
  }

  figure.general:first-of-type p {
    transform: none;
    margin-top: -20px;
  }

  figure.gold:first-of-type ul {
    bottom: -120px;
  }

  figcaption p {
    line-height: 28px;
    font-size: 16px;
    padding-bottom: 0;
  }

  figcaption {
    padding: 30px;
  }

  figure.general-gold > img {
    max-width: 80%;
    margin-left: -45px;
  }

  figure.other {
    flex-basis: 25%;
  }

  .sponsor-dots {
    display: flex;
    justify-content: center;
  }

  figure.general-gold.general:first-of-type ul {
    transform: none;
    top: 40%;
    bottom: auto;
  }

  figure.general-gold.general a.general-gold-main-link {
    width: 60%;
    height: auto;
  }

  .general-slider {
    height: 40%;
  }

  figure.general-gold.general:first-of-type ul {
    top: 30%;
  }

  .sponsor-dots {
    top: 45%;
  }
}

@media screen and (min-width: 1024px) {
    figure.other {
        flex-basis: 15%;
        margin-right: 5%;
    }
}

@media screen and (max-width: 1024px) {
  figure.general-gold.gold {
    width: 60%;
  }

  .general-gold:nth-of-type(2) {
    margin: 65px 0 65px auto;
  }

  figure.general-gold.general:first-of-type ul {
    top: 20%;
  }

  .sponsor-dots {
    top: 40%;
  }

  .general-slider {
    height: 30%;
  }
}

@media screen and (min-width: 1192px) {
  figure.general ul {
    bottom: -20px;
  }

  .general-slider {
    height: 50%;
  }

  .sponsor-dots {
    top: 55%;
  }

   figure.general-gold.general:first-of-type ul {
    top: 40%;
  }
}

@media screen and (min-width: 1250px) {
  .sponsor-dots {
    left: 10%;
  }
}

@media screen and (max-width: 1250px) {
  figure.general-gold.gold p {
    margin-top: 80px;
  }

  figure.general-gold.gold:first-of-type p {
    margin-top: 70px;
  }

  figure.general-gold.gold:first-of-type figcaption img {
    margin-top: 20px;
    margin-left: 10px;
  }
}

@media screen and (min-width: 550px) {
  figure.general-gold.gold p,
  figure.general-gold.gold:first-of-type p {
    margin-top: 50px;
  }

  figure.general-gold.gold:first-of-type figcaption img {
    margin-top: 10px;
  }
}

@media screen and (min-width: 760px) {
  figure.general-gold.gold p {
    margin-top: 70px;
  }

  figure.general-gold.gold:first-of-type p  {
    margin-top: 100px;
  }
}

@media screen and (max-width: 1290px) {
  figure.general-gold.gold ul {
    right: -90px;
  }

  figure.general-gold.gold:nth-of-type(2) ul {
    left: -80px;
  }
}

@media screen and (max-width: 1192px) {
  figure.general-gold.gold ul {
    right: -130px;
  }

  figure.general-gold.gold:nth-of-type(2) ul {
    left: -120px;
  }

  ul {
    max-width: 250px;
  }
}

@media screen and (max-width: 380px) {
  figure.general-gold.gold p {
    margin-top: 50px;
  }

  figure.gold ul {
    max-width: 150px;
    padding: 18px 6px;
  }
}

@media screen and (max-width: 768px) {
  .general-slider {
    height: 100%;
  }

  figure.general-gold.gold {
    width: 80%;
  }

  figure.general-gold.gold ul {
    right: 70px;
  }

  figure.general-gold.gold:nth-of-type(2) ul {
    left: 50px;
  }
}

@media screen and (max-width: 520px) {
  ul {
    max-width: 200px;
  }

  figure.general-gold.gold {
    width: 100%;
  }

  figure.general-gold.gold ul {
    right: 40px;
  }

  figure.general-gold.gold:nth-of-type(2) ul {
    left: 30px;
  }
}

@media screen and (max-width: 410px) {
  figure.general-gold.gold:nth-of-type(2) figcaption img {
    transform: scale(0.3);
    margin-right: -130px;
  }

  figure.general-gold.gold:nth-of-type(3) figcaption img {
    transform: scale(0.25);
    margin-left: -150px;
  }

  figure.general-gold.gold:nth-of-type(2) ul {
    left: 20px;
  }
}

@media screen and (max-width: 510px) {
  figure.general-gold.general:first-of-type ul {
    padding: 15px 5px;
    transform: translateY(-50%);
    max-width: 160px;
  }

  figure.general-gold:first-of-type ul li:last-of-type {
    font-size: 18px;
  }
}
</style>